import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from 'src/app/pages/home/home.component';
import {SupportComponent} from 'src/app/pages/support/support.component';
import {PrivacyPolicyComponent} from 'src/app/pages/privacy-policy/privacy-policy.component';
import {GrievanceFormComponent} from 'src/app/pages/grievance-form/grievance-form.component';
import {FindADentistComponent} from 'src/app/pages/find-a-dentist/find-a-dentist.component';
import {SummaryDiscountsComponent} from 'src/app/pages/summary-discounts/summary-discounts.component';
import {BenefitInfoComponent} from 'src/app/pages/benefit-info/benefit-info.component';
import {AdhaComponent} from 'src/app/pages/adha/adha.component';
import {routes as widgetRoutes} from '@wellfit/wf-plans-widget';
import {purchaseOptionsGuard} from 'src/app/guards/purchase-options.guard';

const routes: Routes = [
  {path: '', component: HomeComponent},
  {path: 'purchase', canActivate: [purchaseOptionsGuard], children: widgetRoutes},
  {path: 'support', component: SupportComponent},
  {path: 'adha/support', component: SupportComponent},
  {path: 'privacy', component: PrivacyPolicyComponent},
  {path: 'greivance', component: GrievanceFormComponent},
  {path: 'adha/greivance', component: GrievanceFormComponent},
  {path: 'find-a-dentist', component: FindADentistComponent},
  {path: 'adha/find-a-dentist', component: FindADentistComponent},
  {path: 'summary-of-discounts', component: SummaryDiscountsComponent},
  {path: 'adha/summary-of-discounts', component: SummaryDiscountsComponent},
  {path: 'benefit-info', component: BenefitInfoComponent},
  {path: 'adha', component: AdhaComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule {}
